const GRAPH = 'GRAPH';
const GLOBAL = 'global';

export const graphQueryKeys = {
    global: [GRAPH, GLOBAL],
    graph: (objectIds?: string) => [GRAPH, String(objectIds)]
};
